<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<!-- 页面名称 -->
				<el-breadcrumb-item v-for="(item,index) in lblMBA" :key="index" v-if="'lbl0'==item.MBAOBJNM" >
					<i class="el-icon-lx-shop"></i>
					{{item.MBAVALUE}}
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" :rules="rules" ref="query" style ="height: 350px;">
				<div class="handle-box">
					<el-row>
						<!-- 检索标签+分割线 -->
						<h2 style="color: #b6b6b6;height: 32px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl1'==item.MBAOBJNM && '0'==item.MBADSPFG" >{{item.MBAVALUE}}</h2>
						<el-divider></el-divider>
						<el-col>
							<el-col :span="24" style="max-height: 25px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl2'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 売上日付 -->
								<el-col :span="3">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<!-- 开始时间 -->
								<el-col :span="7">
									<div class="grid-content " style="width: 260px;">
										<el-form-item prop="start">
											<el-date-picker v-model="query.start"  :clearable="false" type="date" value-format="yyyy-MM-dd" class="handle-time mr10 "></el-date-picker>
										</el-form-item>
									</div>
								</el-col>
								<el-col :span="1"><span>-</span></el-col>
								<!-- 结束时间 -->
								<el-col :span="7">
									<div class="grid-content " style="width: 260px;">
										<el-form-item prop="end">
											<el-date-picker v-model="query.end"  :clearable="false" type="date" value-format="yyyy-MM-dd" class="handle-time mr10"></el-date-picker>
										</el-form-item>
									</div>
								</el-col>
							</el-col>	
							<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl4'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 分类 -->
								<el-col :span="3">
									<span>{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="5" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl5'==item.MBAOBJNM && '0'==item.MBADSPFG">
									<el-select v-model="query.MEBID"  :placeholder="item.MBAVALUE"
									 @change="Get_MEC_List(query.MEBID)">
										<el-option v-for="item in query.optionsMEBID" :key="item.MEBMSTID" :label="item.MEBMNAME" :value="item.MEBMSTID"></el-option>
									</el-select>
								</el-col>
								<el-col :span="5" style = "margin-left: 6px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl6'==item.MBAOBJNM && '0'==item.MBADSPFG">
									<el-select v-model="query.MECID"  :placeholder="item.MBAVALUE"
									 @change="Get_MED_List(query.MECID)">
										<el-option v-for="item in query.optionsMECID" :key="item.MECMSTID" :label="item.MECMNAME" :value="item.MECMSTID"></el-option>
									</el-select>
								</el-col>
								<el-col :span="5" style = "margin-left: 6px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl7'==item.MBAOBJNM && '0'==item.MBADSPFG">
									<el-select v-model="query.MEDID"  :placeholder="item.MBAVALUE">
										<el-option v-for="item in query.optionsMEDID" :key="item.MEDMSTID" :label="item.MEDMNAME" :value="item.MEDMSTID"></el-option>
									</el-select>
								</el-col>
							</el-col>
									<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl9'==item.MBAOBJNM && '0'==item.MBADSPFG">
										<!-- 原作 -->
										<el-col :span="3">
											<span >{{item.MBAVALUE}}</span>
										</el-col>
										<el-col :span="9">
												<el-select class="col-width" v-model="query.MDNNM"  multiple>
													<el-option v-for="item in query.optionsMDNNM" :key="item.MDNMSTID" :label="item.MDNMNAME" :value="item.MDNMSTID"></el-option>
												</el-select>
										</el-col>
									</el-col>
									<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl10'==item.MBAOBJNM && '0'==item.MBADSPFG">
										<!-- 品名 -->
										<el-col :span="3">
											<span >{{item.MBAVALUE}}</span>
										</el-col>
										<el-col :span="9">
											<el-input class="col-width" v-model="query.MDHNM1" ></el-input>
										</el-col>
									</el-col>
									<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl17'==item.MBAOBJNM && '0'==item.MBADSPFG" >
										<!-- シーズン -->
										<el-col :span="3">
											<span>{{item.MBAVALUE}}</span>
										</el-col>
										<el-col :span="9">
											<el-select class="col-width" v-model="query.MDMNM" multiple>
												<el-option v-for="item in query.optionsMDMNM" :key="item.MDMMSTID" :label="item.MDMMNAME" :value="item.MDMMSTID"></el-option>
											</el-select>
										</el-col>								
									</el-col>
									<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl23'==item.MBAOBJNM && '0'==item.MBADSPFG">
										<!-- 会員ランク-->
										<el-col :span="3">
											<span >{{item.MBAVALUE}}</span>
										</el-col>
										<el-col :span="9">
											<el-select class="col-width" v-model="query.PBARNKCT"  multiple>
												<el-option v-for="item in query.optionsPBARNKCT" :key="item.INIKEY02" :label="item.INIVALUE" :value="item.INIKEY02"></el-option>
											</el-select>
										</el-col>
									</el-col>
								</el-col>
							</el-row>
						</div>
				<div class="handle-box">
					<el-row>
						<!-- 检索标签+分割线 -->
						<h2 style=" height: 32px;" ></h2>
						<el-divider></el-divider>
						<el-col>
							<el-col :span="24" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl3'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 店铺 -->
								<el-col :span="3">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="9">
									<el-select class="col-width" v-model="query.MCCID"  multiple>
										<el-option v-for="item in query.optionsMCCID" :key="item.MCCMSTID" :label="item.MCCMNAME" :value="item.MCCMSTID"></el-option>
									</el-select>
								</el-col>
							</el-col>				
							<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl8'==item.MBAOBJNM">
								<!-- メーカー -->
								<el-col :span="3">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="9">
									<el-select class="col-width" v-model="query.MEAID"  multiple>
										<el-option v-for="item in query.optionsMEAID" :key="item.MEAMSTID" :label="item.MEAMNAME" :value="item.MEAMSTID"></el-option>
									</el-select>
								</el-col>
							</el-col>
							<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl11'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 品名2 -->
								<el-col :span="3">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="9">
									<el-input class="col-width" v-model="query.MDHNM2" ></el-input>
								</el-col>
							</el-col>
							<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl21'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 品番 -->
								<el-col :span="3">
									<span>{{ item.MBAVALUE }}</span>
								</el-col>
								<el-col :span="9">
									<el-input class="col-width" v-model="query.MDAID" ></el-input>
								</el-col>
							</el-col>
							<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl22'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 店舗グループ -->
								<el-col :span="3">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="9">
									<el-select class="col-width" v-model="query.MCDID"  multiple>
										<el-option v-for="item in query.optionsMCDID" :key="item.MCDMSTID" :label="item.MCDMNAME" :value="item.MCDMSTID"></el-option>
									</el-select>
								</el-col>
							</el-col>	
						</el-col>
					</el-row>
				</div>
			</el-form>
		</div>
		<div class="container">
			<!-- 公共控件 -->
			<!-- 		<div style="width: 100%; height: 100%;"> -->
			<itemfileselected ref="itemfile" :datarow="datarow" :datacol="datacol" :orderitem="orderitem" :checkitem="checkitem"
			 :sussdata="collist">
				<!-- 			:datasource="datasource" -->
			</itemfileselected>
			<!-- 		</div> -->

			<div v-if="datasource.length>0">
				<el-button style="margin-top: 20px;" type="success" @click="exportcsv()" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl19'==item.MBAOBJNM" >{{item.MBAVALUE}}</el-button>
				<div class="pagination">
					<el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="this. query.pageIndex"
					 :page-sizes="[10, 50, 100]" :page-size="this.query.pageSize" layout="total, sizes, prev, pager, next, jumper"
					 :total="this.query.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import itemfileselected from '@/components/common/itemfileselected.vue';
	export default {
		name: 'Analysissales',
		inject: ['reload'],

		data() {
			//验证字符串
			const validatestart = (rule, value, callback) => {
				if (value == '' || value == undefined || value == null) {
					callback(this.$t('Message.Message_05'));
				} else {
					callback();
				}
			};

			const validateend = (rule, value, callback) => {
				if (value == '' || value == undefined || value == null) {
					callback(this.$t('Message.Message_05'));
				} else {
					callback();
				}
			};

			return {

				pMECPRTID: '',
				pMEDPPRID: '',
				pMEDPRTID: '',
				//	pLNGCT: sessionStorage.getItem('ms_lang'),  //web侧 语言
				query: {

					pageIndex: 1,
					pageSize: 100,
					total: 0,

					MCCID: [], //店铺
					optionsMCCID: [], //店铺取值
					MCDID: [], //店铺
					optionsMCDID: [], //店铺取值
					MEAID: [], //メーカー
					optionsMEAID: [], //メーカー取值
					MEBID: '', //大分类
					optionsMEBID: [], //大分类取值
					MECID: '', //中分类
					optionsMECID: [], //中分类取值
					MEDID: '', //小分类
					optionsMEDID: [], //小分类取值
					MDAID:'',//品番
					MDNNM: '', //原作
					optionsMDNNM: [], //原作取值
					MDHNM1: '', //品名1
					MDHNM2: '', //品名2
					POS01: '', //性别
					optionsPOS01: [], //性别
					POS02: '', //需要
					optionsPOS02: [], //需要
					POS03: '', //客層
					optionsPOS03: [], //客層
					POS04: '', //年代
					optionsPOS04: [], //年代
					MDMNM: '', //シーズン
					optionsMDMNM: [], //シーズン取值
					start: '', //时间开始
					end: '', //结束开始
					hfShopCD: '',
					count: 0,	
					pDELFG:false ,//返金があるものを除外する
					PBARNKCT: [], //会員ランク
					optionsPBARNKCT: [], //会員ランク取值
				},
				// pagesql: '', //页面SQL
				// isbtnEnabled: true, //检索按钮控制

				ShopCD: '',
				pMCBID: sessionStorage.getItem("UserCD"), //b0211f
				pMCCID: sessionStorage.getItem('ShopCD'),
				pCOMLG: sessionStorage.getItem("COMLG"), //30126
				pLNGCT: sessionStorage.getItem("Language"), //语言
				collist: [],
				datasource: [],

				rows: '',
				cols: '',
				jjs: '',
				rpx: '',
				valtype: '',

				datarow: [], //行
				datacol: [], //列
				checkitem: [], //集计
				lblMBA:[],//MBA标签
				strMBB:'',//提示语
				strType:'',//提示类型
				PAGENAME: '',

				orderitem: [{
						INITXT01: 'ASC',
						INIVALUE: this.$t("Analysissales.Analysissales_0"),


					},
					{
						INITXT01: 'DESC',
						INIVALUE: this.$t("Analysissales.Analysissales_1"),

					}
				],

				//验证规则
				rules: {
					// start: [
					// 	{
					// 		required: true,
					// 		trigger: ['blur', 'change'],
					// 		validator: validatestart
					// 	}
					// ],
					// end: [
					// 	{
					// 		required: true,
					// 		trigger: ['blur', 'change'],
					// 		validator: validateend
					// 	}
					// ]
				}
			};
		},
		
		components: {
			itemfileselected
		},
		
		//国际化
		computed: {
			i18n() {
				return this.$t('Analysissales');
			},
			//时间
			starttimeDefault() {
				var date = new Date();
				var datetime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + 1;
				return datetime;
			},
			endtimeDefault() {
				var date = new Date();
			  var datetime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + new Date(date.getFullYear(),(date.getMonth() + 1).toString().padStart(2,'0'),0).getDate();
				return datetime;
			}
		},
		
		created() {
			this.Get_MBA('SalesShopTAB');
			this.query.start = this.starttimeDefault;
			this.query.end = this.endtimeDefault;
			this.Get_MCC_List(); //店铺取值
			this.Get_MCD_List(); //店铺取值
			this.Get_MEA_List(); //メーカー取值
			this.Get_MEB_List(); //大分类取值
			this.Get_MEC_List(); //中分类取值
			this.Get_MED_List(); //小分类取值
			this.Get_INI1_List(); //性别取值
			this.Get_INI2_List(); //需要取值
			this.Get_INI3_List(); //客層取值
			this.Get_INI4_List(); //年代取值
			this.Get_INI5_List(); //会員ランク
			this.Get_INI();
			this.Get_BAG_List(); //获取页面名
			this.Get_MDM_List(); //シーズン
			this.Get_MDN_List(); //原作
		},
		
		methods: {
		    Get_MBA(page) {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MBA';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							APPID: page,
							Language: self.pLNGCT,
							pMCBID: this.pMCBID,
							CompanyCD: sessionStorage.getItem('CompanyCD'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							self.lblMBA = resKKDT;
						}
					})
		    },
		   Get_MBB: async function(id,value1,value2) {
		      const self = this;
		      var postUrl = 'FSMS/Public/Get_MBB';
		      //网络请求接口
		      await this.$axios
		      	.post(
		      		//请求的url
		      		postUrl,
		      		//请求参数
		      		{
		      			pID:id ,
						pMCBID: this.pMCBID,
		      			pLanguage: self.pLNGCT,
						pCOMNM:sessionStorage.getItem('CompanyName'),
						pMCCNM:sessionStorage.getItem('ShopName'),
		      		}
		      	)
		      	.then(response => {
		      		//请求成功返回的数据
		      		let resCount = response.data.KKDTCOUNT;
		      
		      		if (resCount > 0) {
		      			self.strMBB = response.data.KKDT[0].MBBVALUE.toString().replace("{0}",value1).replace('{1}',value2).replace("\\n",'');
		      			if(response.data.KKDT[0].MBBALTCT.toString() == '0'){
		      				self.strType = 'warning';//警告
		      			}else if(response.data.KKDT[0].MBBALTCT.toString() == '1'){
		      				self.strType = 'error';//问题
		      			}else{
		      				self.strType = 'info';//通知
		      			}						
		      		}
		      	})
		     },
		     MBB_check: async function(id,value1,value2){
		     	    await this.Get_MBB(id,value1,value2);		 	
		   	    this.$message({
		   	    	message: this.strMBB, 
		   	    	type: this.strType
		   	    });
		      },

			//店铺
			Get_MCC_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MCC_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMCCID = resKKDT;
						}
					})
					.catch(error => {
                        this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//店铺グループ
			Get_MCD_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MCD_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pMCDID: self.pMCDID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMCDID = resKKDT;
						}
					})
					.catch(error => {
                        this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			//メーカー
			Get_MEA_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MEA_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMEAID = resKKDT;
						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			//大分类
			Get_MEB_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MEB_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMEBID = resKKDT;
						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			//中分类
			Get_MEC_List() {
				const self = this;
				self.pMECPRTID = self.query.MEBID;
				var postUrl = 'FSMS/Public/Get_MEC_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pMECPRTID: self.pMECPRTID,
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMECID = resKKDT;
						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			//小分类
			Get_MED_List() {
				const self = this;
				self.pMEDPPRID = self.query.MEBID;
				self.pMEDPRTID = self.query.MECID;
				var postUrl = 'FSMS/Public/Get_MED_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pMEDPPRID: self.pMEDPPRID,
							pMEDPRTID: self.pMEDPRTID,
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMEDID = resKKDT;
						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			
			//グループ1
			Get_MDM_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MDM_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMDMNM = resKKDT;
						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			
			//グループ2
			Get_MDN_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MDN_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMDNNM = resKKDT;
						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//性别
			Get_INI1_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10007",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS01 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//需要
			Get_INI2_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10008",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS02 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//客層
			Get_INI3_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10009",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS03 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//年代
			Get_INI4_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10010",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS04 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//会員ランク
			Get_INI5_List() {
			    const self = this;
			    var postUrl = 'FSMS/Public/Get_INIInfo_List';
			    //网络请求接口
			    this.$axios
			        .post(
			            //请求的url
			            postUrl,
			            //请求参数
			            {
			                pMCBID: self.pMCBID,
			                pMCCID: self.pMCCID,
			                pCOMID: sessionStorage.getItem('CompanyCD'),
			                pLNGCT: self.pLNGCT, //语言
			                pKEY01: "10045",
			                pCOMNM:sessionStorage.getItem('CompanyName'),
			                pMCCNM:sessionStorage.getItem('ShopName'),
			
			            }
			        )
			        .then(response => {
			            //请求成功返回的数据
			            let resCount = response.data.KKDTCOUNT;
			            if (resCount > 0) {
			                let resKKDT = response.data.KKDT;
			                this.query.optionsPBARNKCT = resKKDT;
			            }
			        })
			        .catch(error => {
			                this.MBB_check('10181','','');//通信エラーが発生しました。
			        });
			},						
			//获取INI
			Get_INI() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INI_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pKEY01: '30011',
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							let arrROW = []; //获取行数据
							let arrLIST = []; //获取列数据
							let arrSETMETER = []; //获取集计数据
							//0、1、2：lable区分：0行数据，1列数据，2集计数据
							for (let list of resKKDT) {
								let obj = {};
								if (list.INIMNAME == '0') {
									obj = list;
									arrROW.push(obj);
								} else if (list.INIMNAME == '1') {
									obj = list;
									arrLIST.push(obj);
								} else {
									obj = list;
									arrSETMETER.push(obj);
								}
							}
							self.datarow = arrROW;
							self.datacol = arrLIST;
							self.checkitem = arrSETMETER;

						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//获取页面名
			Get_BAG_List(){
				const self = this;
				var postUrl = 'FSMS/Public/Get_BAG_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
							pPATH: "/FSBI/Analysis_sales/Analysis_sales",
						}
					)
					.then(response => {
						//请求成功返回的数据
						this.PAGENAME = response.data.KKSTR;
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			getcolcount(col, lpx, rows, jj) {

				rows = rows.toString().substring(0, rows.length - 1);
				if (this.query.start == null || this.query.end == null) {
					this.MBB_check('10101','売上日付','');
					this.$refs.itemfile.loadflag = false;
					return;
				}

				const self = this;
				let queryBar = [];
				// this.collist=[];
				let obj = {};
				obj.start = this.query.start;
				obj.end = self.query.end;
				obj.MCCID = self.query.MCCID.join("-");
				obj.MCDID = self.query.MCDID.join("-");
				obj.PBARNKCT = self.query.PBARNKCT.join("-");//会员等级
				obj.MEAID = self.query.MEAID.join("-");
				obj.MEBID = self.query.MEBID;
				obj.MECID = self.query.MECID;
				obj.MEDID = self.query.MEDID;
				if (self.query.MDNNM==""){
				obj.MEENM = "";
				}else{
				obj.MEENM = self.query.MDNNM.join("-");
				}
				obj.MDAID = self.query.MDAID;
				obj.POS01 = self.query.POS01;
				obj.POS02 = self.query.POS02;
				obj.POS03 = self.query.POS03;
				obj.POS04 = self.query.POS04;
				obj.MDHNM1 = self.query.MDHNM1;
				obj.MDHNM2 = self.query.MDHNM2;
				obj.MDMNM = self.query.MDMNM.join("-");
				obj.DELFG = self.query.pDELFG;
				queryBar.push(obj);
				let url = 'BI/BI/Get_TAB_Count';
				this.$axios.post(
						url, {

							pMCBID: this.pMCBID,
							pMCCID: '',
							pMCDID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							column: col, //勾选列字段
							qUERYTABLE: JSON.stringify(queryBar),
							rows:rows,
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}

					).then((response) => {
						//请求成功返回的数据

						this.query.count = response.data.KKDTCOUNT;

						if (this.query.count > 0) {
							if (col.split(',').length > 1 && jj.length > 1) {
								if (this.query.count > 10000) {
									this.MBB_check('10197','データ件数','10000');//{0}が{1}件を超えています。検索条件を見直してください
									this.$refs.itemfile.loadflag = false;
									return;
								} else {
									this.getcol(col,rows,jj, lpx);
								}
							} else {

								if (this.query.count > 30000) {
									this.MBB_check('10197','データ件数','30000');//{0}が{1}件を超えています。検索条件を見直してください
									this.$refs.itemfile.loadflag = false;
									return;
								} else {
									this.getcol(col,rows,jj, lpx);
								}
							}
						} else {

							this.datasource = [];
							this.MBB_check('10010','','');//沒有滿足條件的資料。
							sessionStorage.setItem('Loading', false);
							this.$refs.itemfile.loadflag = false;
						}
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});

			},

			getcol(col,rows,jj, lpx) {
				this.datasource = [];
				const self = this;
				let queryBar = [];
				// this.collist=[];
				let obj = {};   
				obj.start = this.query.start;
				obj.end = self.query.end;
				obj.MCCID = self.query.MCCID.join("-");
				obj.MCDID = self.query.MCDID.join("-");
				obj.PBARNKCT = self.query.PBARNKCT.join("-");//会员等级
				obj.MEAID = self.query.MEAID.join("-");
				obj.MEBID = self.query.MEBID;
				obj.MECID = self.query.MECID;
				obj.MEDID = self.query.MEDID;
				if (self.query.MDNNM==""){
				obj.MEENM = "";
				}else{
				obj.MEENM = self.query.MDNNM.join("-");
				}
				obj.MDAID = self.query.MDAID;
				obj.POS01 = self.query.POS01;
				obj.POS02 = self.query.POS02;
				obj.POS03 = self.query.POS03;
				obj.POS04 = self.query.POS04;
				obj.MDHNM1 = self.query.MDHNM1;
				obj.MDHNM2 = self.query.MDHNM2;
				obj.MDMNM = self.query.MDMNM.join("-");
				obj.DELFG = self.query.pDELFG;
				queryBar.push(obj);
				let url = 'BI/BI/Get_TAB_List';
				this.$axios.post(
						url, {

							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							rows: rows,//勾选行字段
							jj: jj,//勾选集计字段
							column: col, //勾选列字段
							lpx: lpx, // 排序
							qUERYTABLE: JSON.stringify(queryBar),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}

					).then((response) => {
						//请求成功返回的数据
						if (response.data.KKDTCOUNT > 0) {
							this.collist = response.data.KKDT;

						} else {
							this.collist = [];
						}

					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});

			},

			getCount(row, col, jj, rpx, valtype) {
				this.datasource = [];
				this.query.total = 0;
				row = row.toString().substring(0, row.length - 1);
				jj = jj.toString().substring(0, jj.length - 1);
				valtype = valtype.toString().substring(0, valtype.length - 1);
				let url = 'FSMS/Public/Get_Count';
				this.$axios.post(
						url, {
							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							row: row, //勾选行字段
							col: col, // 列
							jj: jj,
							sessioname: 'AnalysissalesTAB',
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}

					).then((response) => {
						this.query.total = 0;
						//请求成功返回的数据
						this.query.total = Number(response.data.KKDTCOUNT);

						if (this.query.total > 0) {
							this.rows = row;
							this.cols = col;
							this.jjs = jj;
							this.rpx = rpx;
							this.valtype = valtype;

							this.getSource(1);
						} else {
							this.query.total = 0;
							this.datasource = [];
						}
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			getSource(page) {
				this.datasource = [];
				let url = 'FSMS/Public/Get_Source';
				this.$axios.post(
						url, {
							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							RolKey: this.rows, //勾选行字段
							ColKey: this.cols, // 列
							SvlKey: this.jjs, //集集
							sessioname: 'AnalysissalesTAB', //跟自己页面的wcf session名字得对上
							rpx: this.rpx,
							valtype: this.valtype,
							pageSize: this.query.pageSize,
							pageIndex: page,
                            MoneyMark:sessionStorage.getItem('MoneyMark'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						
						}

					).then((response) => {
						//请求成功返回的数据
						this.$refs.itemfile.loadflag = false;
						this.datasource = response.data.KKDT;
						this.$refs.itemfile.datasource = this.datasource;
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			handleSizeChange(size) {
				this.$refs.itemfile.loadflag = true;
				this.query.pageIndex = 1;
				this.query.pageSize = size;
				this.getSource(1);

			},
			handlePageChange(curpage) {
				this.$refs.itemfile.loadflag = true;
				// this.$set(this.query,"pageIndex",curpage);
				this.query.pageIndex = curpage;
				this.getSource(curpage);

			},
			exportcsv() {
				let name = '';
				let csvrowname = this.$refs.itemfile.csvrowname;
				let csvjjname = this.$refs.itemfile.csvjjname;

				if (csvjjname.length > 0) {
					csvjjname = csvjjname.substring(0, csvjjname.length - 1);
					name = csvrowname + csvjjname;
				} else {
					csvrowname = csvrowname.substring(0, csvrowname.length - 1);
					name = csvrowname;
				}

				let url = 'FSMS/Public/GetExport';
				this.$axios.post(
						url, {
							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: this.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							pTimeZone: sessionStorage.getItem('TimeZone'),
							pIP: sessionStorage.getItem('IP'),
							thHead: name,
							printType: "csv",
							pagenm: this.PAGENAME,
							pageid: 'sys_Analysis_sales',
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}

					).then((response) => {
						//请求成功返回的数据
						let url = response.data.KKSTR;
						if(url != "False") {
							window.open(this.basehtmlURL + url);
						}
						else{
							this.MBB_check('10238','','');//数据打印失败。
						}			  		
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});

			},

			reset() {
				this.reload();
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
		width: 50%;
		float: left;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.green {
		color: green;
	}

	.blue {
		color: #00aaff;
	}

	.orange {
		color: #ff5500;
	}

	.handle-select {
		width: 70%;
	}

	.handle-selectn {
		width: 70%;
	}

	.handle-time {
		width: 90%;
	}

	.grid-contentn {
		min-height: 36px;
	}

	.lable-site {
		width: 40px;
		height: 40px;
	}

	.col-width {
		width: 170%;

	}
</style>
